module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"message":"Ny version av Memolife tilgjengelig","messageShort":"Ny version tilgjengelig","button":"Oppdater nå"},"en":{"message":"New version of Memolife available","messageShort":"New version available","button":"Update Now"}}')
  delete Component.options._Ctor
}
